const kisIoSvg =
	'<?xml version="1.0" encoding="UTF-8" standalone="no"?>' +
	'<svg' +
	'   xmlns:dc="http://purl.org/dc/elements/1.1/"' +
	'   xmlns:cc="http://creativecommons.org/ns#"' +
	'   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"' +
	'   xmlns:svg="http://www.w3.org/2000/svg"' +
	'   xmlns="http://www.w3.org/2000/svg"' +
	'   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"' +
	'   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"' +
	'   width="100%"' +
	'   height="100%"' +
	'   viewBox="0 0 300 700"' +
	'   version="1.1"' +
	'   xml:space="preserve"' +
	'   style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"' +
	'   id="2838d8a7-0cbd-410e-928d-9b1a9a05c8a6_inDigitalTwinWidget"' +
	'   sodipodi:docname="kis_io.svg"' +
	'   inkscape:version="1.0.2 (e86c870879, 2021-01-15, custom)"><path' +
	'   id="kisIo-body"' +
	'   d="M261,40c0,-5.519 -4.481,-10 -10,-10l-200,0c-5.519,0 -10,4.481 -10,10l0,580c0,5.519 4.481,10 10,10l200,0c5.519,0 10,-4.481 10,-10l0,-580Z"' +
	'   style="fill:#505557;" />            <g' +
	'   id="di-online-indicator"' +
	'   style="fill: rgb(255, 0, 0);"><circle' +
	'   cx="151"' +
	'   cy="571"' +
	'   r="16"' +
	'   id="circle13" />        <path' +
	'   d="M151,558c7.132,0 13,5.868 13,13c0,7.132 -5.868,13 -13,13c-7.132,0 -13,-5.868 -13,-13c0,-7.132 5.868,-13 13,-13m0,-3c-8.777,0 -16,7.223 -16,16c0,8.777 7.223,16 16,16c8.777,0 16,-7.223 16,-16c0,-8.777 -7.223,-16 -16,-16Z"' +
	'   style="fill:#fff;fill-rule:nonzero;"' +
	'   id="path15" /></g>    <path' +
	'   id="sbox-plug"' +
	'   d="M116,630l0,19.15l10,0l0,30.85l50,0l0,-30.85l10,0l0,-19.15l-70,0Z"' +
	'   style="fill:#444;fill-rule:nonzero;" />    <rect' +
	'   id="marker"' +
	'   x="10"' +
	'   y="10"' +
	'   width="280"' +
	'   height="680.274"' +
	'   style="fill:none;stroke:#f00;stroke-width:20px;visibility:hidden" />	 <g' +
	'   id="alert"' +
	'   style="visibility:hidden">		<rect' +
	'   x="38.565"' +
	'   y="30.39"' +
	'   width="221.181"' +
	'   height="599.851"' +
	'   style="fill:#808080;fill-opacity:0.7;"' +
	'   id="rect20" />		<path' +
	'   d="M164.84,369.124l-37.354,0c-0.098,-5.371 -0.146,-8.643 -0.146,-9.815c0,-12.109 2.002,-22.07 6.006,-29.882c4.003,-7.813 12.011,-16.602 24.023,-26.368c12.012,-9.765 19.189,-16.162 21.533,-19.189c3.613,-4.785 5.42,-10.059 5.42,-15.82c0,-8.008 -3.198,-14.868 -9.595,-20.581c-6.396,-5.713 -15.014,-8.57 -25.854,-8.57c-10.449,0 -19.19,2.979 -26.221,8.936c-7.031,5.957 -11.865,15.039 -14.502,27.246l-37.793,-4.688c1.074,-17.48 8.521,-32.324 22.339,-44.531c13.818,-12.207 31.958,-18.31 54.419,-18.31c23.633,0 42.432,6.176 56.397,18.53c13.964,12.353 20.947,26.733 20.947,43.14c0,9.082 -2.564,17.675 -7.691,25.781c-5.127,8.105 -16.089,19.14 -32.885,33.105c-8.692,7.227 -14.087,13.037 -16.187,17.432c-2.1,4.394 -3.052,12.256 -2.856,23.584Zm-37.354,55.371l0,-41.162l41.162,0l0,41.162l-41.162,0Z"' +
	'   style="fill:#fff;fill-rule:nonzero;"' +
	'   id="path22" />	 </g>    <defs' +
	'   id="defs35">		<radialGradient' +
	'   id="_Radial1"' +
	'   cx="0"' +
	'   cy="0"' +
	'   r="1"' +
	'   gradientUnits="userSpaceOnUse"' +
	'   gradientTransform="matrix(60.1041,-60.1041,360.624,360.624,151.002,429.996)">			<stop' +
	'   offset="0"' +
	'   style="stop-color:#fff;stop-opacity:1"' +
	'   id="stop25" /><stop' +
	'   offset="1"' +
	'   style="stop-color:#222;stop-opacity:1"' +
	'   id="stop27" />		</radialGradient>       <radialGradient' +
	'   id="_Radial2"' +
	'   cx="0"' +
	'   cy="0"' +
	'   r="1"' +
	'   gradientUnits="userSpaceOnUse"' +
	'   gradientTransform="matrix(60.1041,-60.1041,360.624,360.624,150.996,222.999)">		 <stop' +
	'   offset="0"' +
	'   style="stop-color:#fff;stop-opacity:1"' +
	'   id="stop30" />        <stop' +
	'   offset="1"' +
	'   style="stop-color:#222;stop-opacity:1"' +
	'   id="stop32" />        </radialGradient>    </defs></svg>';
export default kisIoSvg;
